<div class="wrapper">
  <span class="spinner"></span>
</div>
